<template>
  <div class="partners-profile-view">
    <div class="d-flex align-items-center justify-content-between">
      <h5 class="text-semibold">
        {{ isEdit ? "Editar perfil" : "Adicionar perfil" }}
      </h5>
      <div class="d-flex gap-2">
        <snow-button
          size="sm"
          text="Cancelar"
          variant="gray"
          @click="$router.push({ name: 'tools-partners' })"
        />
        <snow-button
          size="sm"
          text="Salvar"
          :disabled="!isValid"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
    <form>
      <div class="d-flex flex-column mb-4">
        <snow-input v-model="form.name" label="Nome do perfil" id="name" />
        <div class="d-flex justify-content-end">
          <small
            class="text-secondary"
            :class="{ 'text-danger': form.name && form.name.length > 64 }"
          >
            {{ `${form.name ? form.name.length : 0}/64` }}
          </small>
        </div>
      </div>
      <action-dispatcher
        action="partnersCenter/getPermissions"
        :loading="false"
      >
        <div class="d-flex flex-column gap-4">
          <snow-checkboxes-dropdown
            v-for="category in permissions"
            :key="category.code"
            :placeholder="category.name"
            :value="
              form.scope.filter(scope =>
                category.permissions.map(p => p.code).includes(scope)
              )
            "
            @input="updateCategoryScope(category, $event)"
            :options="
              category.permissions.map(p => ({
                id: p.code,
                label: p.name
              }))
            "
          />
        </div>
      </action-dispatcher>
    </form>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers.js";
import { mapState } from "vuex";

export default {
  data() {
    return {
      ...formFields(["name", "scope"], {
        name: "",
        scope: []
      }),
      loading: false,
      errors: {}
    };
  },
  computed: {
    ...mapState("partnersCenter", ["permissions", "profiles"]),
    isEdit() {
      return !!this.$route.query.id;
    },
    item() {
      if (!this.isEdit) return null;
      return this.profiles.find(p => p.id == this.$route.query.id) || null;
    },
    isValid() {
      return this.form.name && this.form.name.length <= 64;
    },
    filteredCategories() {
      let options = {};
      this.permissions.forEach(
        category =>
          (options[category.name] = this.form.scope.filter(scope =>
            category.permissions.map(p => p.code).includes(scope)
          ))
      );
      return options;
    }
  },
  methods: {
    submit() {
      const data = {
        ...this.form,
        scope: Object.values(this.filteredCategories).flat()
      };
      data.scope = data.scope.reduce((prev, cur) => {
        const obj = { ...prev };
        obj[cur] = ["read", "update", "write", "delete"];
        return obj;
      }, {});

      let action = "partnersCenter/postProfile";
      if (this.isEdit) {
        action = "partnersCenter/putProfile";
        data.id = this.$route.query.id;
      }

      this.loading = true;
      this.$store
        .dispatch(action, data)
        .then(({ data }) => {
          this.$message.success(
            this.isEdit ? "Colaborador editado" : "Convite enviado"
          );
          this.$router.push({ name: "tools-partners" });
        })
        .catch(error => {
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    updateCategoryScope(category, values) {
      const categoryCodes = category.permissions.map(p => p.code);

      this.form.scope = [
        ...this.form.scope.filter(scope => !categoryCodes.includes(scope)),
        ...values
      ];
    }
  },
  mounted() {
    if (this.isEdit && !this.item) {
      this.$store
        .dispatch("partnersCenter/getProfile", this.$route.query.id)
        .then(profile => {
          this.form.name = profile.name;
          this.form.scope = Object.keys(profile.scope);
        });
    }
    if (this.isEdit && this.item) {
      this.form.name = this.item.name;
      this.form.scope = Object.keys(this.item.scope);
    }
  }
};
</script>

<style scoped lang="scss">
.partners-profile-view {
  background: var(--bg-2);
  padding: 24px;
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
